var map = {
	"./abz-works/abz-works-website.png": 6958,
	"./abz-works/logo.svg": 9489,
	"./arete/arete-logo.png": 3888,
	"./arete/arete-website.png": 8610,
	"./cps/cps-website.png": 5542,
	"./cps/logo.svg": 6141,
	"./ekf/ekf-website.png": 9838,
	"./ekf/logo.svg": 4515,
	"./just-enterprise/just-enterprise-website.png": 1510,
	"./just-enterprise/logo.png": 19,
	"./nhs/logo.svg": 222,
	"./nhs/nhs-landing-page.png": 4538,
	"./nhs/nhs-website-children.png": 800,
	"./nhs/nhs-website-young-people.png": 9501,
	"./p4s/logo.png": 2876,
	"./p4s/p4s-homepage.png": 7893,
	"./p4s/p4s-website-portfolio.png": 9613,
	"./prodpad/gutenberg-blocks-video-poster.png": 1614,
	"./prodpad/gutenberg-blocks-video.mp4": 4286,
	"./prodpad/logo.png": 8287,
	"./prodpad/prodpad-app-dashboard.png": 9915,
	"./prodpad/prodpad-app-product-portfolio.png": 565,
	"./prodpad/prodpad-glossary-page.png": 2069,
	"./prodpad/prodpad-homepage.png": 2233,
	"./scf/logo.svg": 2445,
	"./scf/scf-website.png": 5222,
	"./tzari/logo.svg": 3157,
	"./tzari/tzari-website.png": 7582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6247;